import _ from 'lodash';

class StoreAPI {
  listController: AbortController[];

  storeController: Record<string, AbortController[]>;

  constructor() {
    this.listController = [];
    this.storeController = {};
  }

  log = (action = 'push') => {
    console.log(`listController >> ${action}: `, _.cloneDeep(this.listController));
  };

  push = (api: AbortController) => {
    if (!_.includes(this.listController, api)) {
      this.listController.push(api);
      // this.log();
    }
  };

  getAPI = () =>
    // this.log('GET API');
    // Prevent mutate the list
    _.cloneDeep(this.listController);

  remove = (api: AbortController) => {
    _.remove(this.listController, (d) => d === api);
    // this.log('REMOVE API');
  };

  removeListAPI = () => {
    this.listController = [];
  };

  abortAPI = (controller: AbortController) => {
    if (!controller) return;
    try {
      controller.abort();
    } catch (error) {
      // error
    }
  };

  cancelAPI = () => {
    // this.log('CANCEL API');
    _.forEach(this.listController, (d) => this.abortAPI(d));
    this.removeListAPI();
  };

  // For group API which want to manager independence
  createStore = (key: string) => {
    this.storeController[key] = [];
  };

  pushStore = (key: string, api: AbortController) => {
    if (!(key in this.storeController)) {
      this.createStore(key);
    }
    if (key in this.storeController && !_.includes(this.storeController?.[key], api)) {
      this.storeController[key].push(api);
    }
  };

  removeStore = (key: string, api: AbortController) => {
    if (key in this.storeController && _.isArray(this.storeController?.[key])) {
      _.remove(this.storeController?.[key], (d) => d === api);
    }
  };

  // remove controller from storeController
  removeStoreCancelAPI = (key: string | null, api: AbortController) => {
    if (key) {
      this.removeStore(key, api);
    } else {
      this.remove(api);
    }
  };

  // push controller into storeController
  pushStoreCancelAPI = (key: string | null, api: AbortController) => {
    if (key) {
      this.pushStore(key, api);
    } else {
      this.push(api);
    }
  };

  destroyStore = (key: string) => {
    if (key in this.storeController) {
      delete this.storeController?.[key];
    }
  };

  cancelStore = (key: string) => {
    if (key in this.storeController && _.isArray(this.storeController[key])) {
      _.forEach(this.storeController[key], (d) => this.abortAPI(d));
      this.storeController[key] = [];
    }
  };

  resetStore = () => {
    this.storeController = {};
  };

  cancelAllStore = () => {
    Object.keys(this.storeController).forEach((key) => {
      _.forEach(this.storeController[key], (d) => this.abortAPI(d));
    });
    this.resetStore();
  };

  getStore = (key: string) => {
    if (key in this.storeController) {
      return this.storeController[key];
    }
    return null;
  };
}

const managerAPI = new StoreAPI();

export default managerAPI;
